/*@ngInject*/
const UtcDateFilter = function () {
    return function (date, format, useLocalTime) {
        if (!_.isNil(date)) {
            return !!useLocalTime ? moment(new Date(date)).format(format) : moment.utc(date).format(format);
        } else {
            return '';
        }
    };
};

angular.module('umCore')
    .filter('utcDateFilter', UtcDateFilter);
